export default [

     {
          path: '/emergency-drill',
          name: 'EmergencyDrill',
          component: () => import("@/views/Page/EmergencyDrill/EmergencyDrill.vue"),
           meta: {
               title: '#Default# | EmergencyDrill',
          },
     }
];